//this utility function lets you intercept every fetch() call in your app, detect when a 401 Unauthorized error occurs
// globalFetchInterceptor.js
export const interceptorAPI_Calls = (setShowModal) => {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

      const requestUrl = args[0];
     // console.log("requestedURL:",requestUrl)
      const isLoginRequest = typeof requestUrl === "string" && requestUrl.includes("/credentials/login");
      //console.log("isLoginRequest:",isLoginRequest)

    if (response.status === 401  && !isLoginRequest) {
      setShowModal(true); // directly update your modal state
    }

    return response;
  };
};
